import React, { Component } from "react";
import { Row, Col, Form, Input, Button, message } from "antd";
import { connect } from "react-redux";
import {filterUserData, sendSMSLogin, setToken, userVerifyCode} from "../../../actions/authActions";
import style from "./login.css";

const FormItem = Form.Item;

class NeedVerifyPhonePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phone: "",
      code: "",
      loading: false,
      loadingVerify: false,
      timer: 60,
      resendDisabled: false,
    };
  }

  // Function to start the resend timer
  startResendTimer = () => {
    this.setState({ resendDisabled: true });
    let countdown = setInterval(() => {
      if (this.state.timer === 0) {
        clearInterval(countdown);
        this.setState({ resendDisabled: false, timer: 60 });
      } else {
        this.setState((prevState) => ({ timer: prevState.timer - 1 }));
      }
    }, 1000);
  };

  // Handle form submission for OTP verification
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({ loadingVerify: true });
        // Call API to verify the code
        userVerifyCode(values.phone, values.code)
          .then((response) => {
            const { data } = response.data;
            const user = filterUserData(data);
            // If verified, set the token and redirect
            this.props.setToken(data.accessToken, user);
            message.success("Phone verified successfully.");
            this.props.history.push("/");
          })
          .catch((error) => {
            message.error("Verification failed. Please check the code.");
            this.setState({ loadingVerify: false });
          });
      }
    });
  };

  // Handle resending the OTP code
  handleResendCode = () => {
    if (!this.state.phone) {
      return message.error("Please enter your phone number to resend the code.");
    }

    this.setState({ loading: true });
    // Call API to resend the code
    sendSMSLogin(this.state.phone)
      .then((response) => {
        message.success("Verification code sent. Please check your phone.");
        this.setState({ loading: false });
        this.startResendTimer(); // Start the resend countdown
      })
      .catch((error) => {
        message.error("Failed to send the verification code.");
        this.setState({ loading: false });
      });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Row>
        <Col
          xs={{ span: 24, offset: 0 }}
          sm={{ span: 16, offset: 4 }}
          md={{ span: 8, offset: 8 }}
          lg={{ span: 8, offset: 8 }}
          xl={{ span: 8, offset: 8 }}
          className="col-login"
        >
          <Form
            className="wrap-login-form"
            onSubmit={this.handleSubmit}
            style={{
              background: "rgba(255, 255, 255, 0.9)",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            <h2 style={{ textAlign: "center", marginBottom: "30px" }}>Verify Your Phone Number</h2>

            <FormItem>
              {getFieldDecorator("phone", {
                rules: [
                  { required: true, message: "Please input your phone number!" },
                ],
              })(
                <Input
                  className={style.input}
                  placeholder="Phone Number"
                  onChange={(e) => this.setState({ phone: e.target.value })}
                />
              )}
            </FormItem>

            <FormItem>
              {getFieldDecorator("code", {
                rules: [
                  { required: true, message: "Please input the verification code!" },
                ],
              })(
                <Input
                  className={style.input}
                  placeholder="Verification Code"
                />
              )}
            </FormItem>

            <Button
              type="primary"
              htmlType="submit"
              disabled={this.state.loadingVerify}
              loading={this.state.loadingVerify}
              className={style.button}
              style={{ width: "100%", marginBottom: "20px" }}
            >
              Verify Code
            </Button>

            <Button
              type="primary"
              loading={this.state.loading}
              disabled={this.state.resendDisabled}
              onClick={this.handleResendCode}
              className={style.button}
              style={{ width: "100%" }}
            >
              Send Code {this.state.resendDisabled ? `(${this.state.timer}s)` : ""}
            </Button>
          </Form>
        </Col>
      </Row>
    );
  }
}

const WrappedNeedVerifyPhonePage = Form.create()(NeedVerifyPhonePage);

export default connect(null, { setToken })(WrappedNeedVerifyPhonePage);



// WEBPACK FOOTER //
// ./src/components/Settings/Login/NeedVerifiedPhone.js